import { useEffect, useRef } from 'react';
import { useAuthStore } from '@/store/useAuthStore';

const MIN_INTERVAL = 4 * 60 * 1000;
const MAX_INTERVAL = 6 * 60 * 1000;
const randomInterval = () => Math.floor(Math.random() * (MAX_INTERVAL - MIN_INTERVAL + 1)) + MIN_INTERVAL;

/**
 * Refreshes the access token on a recurring timer instead of waiting for it to
 * expire, since merchant-api's refresh-token endpoint requires a still-valid
 * access token to exchange (an already-expired one can't be recovered from).
 * Keeps retrying indefinitely rather than ever forcing a logout on its own.
 */
export function useAutoRefreshToken(enabled) {
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!enabled) return undefined;

    const tick = () => {
      timeoutRef.current = setTimeout(async () => {
        if (useAuthStore.getState().refreshToken) {
          await useAuthStore.getState().refreshTokens().catch(() => {});
        }
        tick();
      }, randomInterval());
    };

    tick();
    return () => clearTimeout(timeoutRef.current);
  }, [enabled]);
}
